import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimTypeDealerAutomationRule.Save.IRequest;
type Params = Api.Core.ClaimTypeDealerAutomationRule.Save.IParams;
type Response = Api.Core.ClaimTypeDealerAutomationRule.Save.IResponse;
type Headers = Api.Core.ClaimTypeDealerAutomationRule.Save.IHeaders;
const saveApiClaimTypeDealerAutomationRulePath = '/api/DealerManagement/ClaimTypeDealerAutomationRule/:claimTypeId';
export default async function claimTypeDealerAutomationRuleSaveApi(
  body: Request,
  params: Params
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(saveApiClaimTypeDealerAutomationRulePath, {
      claimTypeId: params?.claimTypeId || body?.claimTypeId || body?.claimTypeAutomationRule?.claimTypeId,
    }),
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    body: body,
    headers: getDefaultHeaders(),
  });
}
